import { SidebarPortal } from '@plone/volto/components';
import { withBlockExtensions } from '@plone/volto/helpers';
import VinculatedColumnSlateData from './Data';
import VinculatedColumnSlateView from './View';

const VinculatedColumnSlateEdit = (props) => {
  const { data, onChangeBlock, block, selected } = props;
  return (
    <>
      <VinculatedColumnSlateView {...props} />
      <SidebarPortal selected={selected}>
        <VinculatedColumnSlateData
          key={block}
          {...props}
          data={data}
          block={block}
          onChangeBlock={onChangeBlock}
        />
      </SidebarPortal>
    </>
  );
};

export default withBlockExtensions(VinculatedColumnSlateEdit);
